export default __webpack_public_path__ + "static/media/neuroshield-logo1.978dd30c.png";